declare global {
  interface Window {
    createLemonSqueezy?: () => void;
    LemonSqueezy?: {
      Url: {
        Open: (url: string) => void;
        Close: () => void;
      };
      Setup: (options: { eventHandler?: (event: { event: string; data: unknown }) => void }) => void;
    };
  }
}

let lemonLoading: Promise<void> | null = null;

export function loadLemonSqueezyScript(): Promise<void> {
  if (window.LemonSqueezy) return Promise.resolve();
  if (lemonLoading) return lemonLoading;

  lemonLoading = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://assets.lemonsqueezy.com/lemon.js";
    script.async = true;
    script.onload = () => {
      if (window.createLemonSqueezy) {
        window.createLemonSqueezy();
      }
      resolve();
    };
    script.onerror = () => reject(new Error("LemonSqueezy script failed to load."));
    document.head.appendChild(script);
  });
  return lemonLoading;
}

export async function openLemonSqueezyCheckout(checkoutUrl: string) {
  try {
    await loadLemonSqueezyScript();
    if (window.LemonSqueezy) {
      window.LemonSqueezy.Url.Open(checkoutUrl);
      return;
    }
  } catch {
    // Fallback: direct window redirect if overlay script blocked
  }
  window.open(checkoutUrl, "_blank");
}
